import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { CoreModule } from 'src/app/core/core.module';
import { GlobalHttpInterceptorService } from 'src/app/core/services/global-http-interceptor.service';
import { GlobalErrorHandlerService } from 'src/app/core/services/global-error-handler.service';
import { LoginComponent } from 'src/app/login/login.component';
import { MultiTranslateHttpLoader } from 'src/app/shared/util/custom-translate.service';
import { DragulaModule } from 'ng2-dragula';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ToastrModule } from 'ngx-toastr';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ModuleNotAllowedComponent } from './module-not-allowed/module-not-allowed.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

registerLocaleData(localeDe);

export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: '/assets/i18n/' },
    { prefix: '/assets/i18n/dashboard/' },
    { prefix: '/assets/i18n/menu-creator/' },
    { prefix: '/assets/i18n/analytics/' },
    { prefix: '/assets/i18n/daily-menu/' },
    { prefix: '/assets/i18n/event-catering/' },
    { prefix: '/assets/i18n/production-plan/' },
    { prefix: '/assets/i18n/erp/' },
    { prefix: '/assets/i18n/sidebar/' },
    { prefix: '/assets/i18n/supplier/' },
    { prefix: '/assets/i18n/settings/' }
  ]);
}

@NgModule({
  declarations: [AppComponent, LoginComponent, ModuleNotAllowedComponent, NotFoundComponent, ResetPasswordComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    ToastrModule.forRoot(),
    DragulaModule.forRoot(),
    ModalModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      }
    }),
    BrowserAnimationsModule,
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
